import { UserRound, Mail, Phone } from "lucide-react";
import React, { useState, useEffect, useCallback } from "react";

import ParagraphTag from "../../reusebale/Paragraph";

import { useSelector } from "react-redux";

import BaseUrl from "../../../constants/BaseUrl";

const LandlordProfile = () => {
  const { loginSuccess } = useSelector((state) => state.auth);

  const [profileInfo, setProfileInfo] = useState();

  const GetProfileInformation = useCallback(() => {
    const landlordId = loginSuccess?.user?.landlordId?.[0]?.id;
    if (!landlordId) {
      console.error("Landlord ID not found");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/getProfileDetails/${landlordId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setProfileInfo(result.data);
        }
      })
      .catch((error) => console.error(error));
  }, [loginSuccess]);

  useEffect(() => {
    GetProfileInformation();
  }, [GetProfileInformation]);

  return (
    <div>
      <div className="mt-5">
        <div className="w-full bg-white rounded-xl">
          <div className="px-4 pt-7">
            <ParagraphTag
              content="Landlord Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="mt-1 ml-4">
            <div className="flex flex-col gap-y-5 w-full py-7">
              <div className=" flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <UserRound color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Name"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.personalInformation?.firstName} ${profileInfo?.personalInformation?.lastName}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className=" flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Mail color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Email Address"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.personalInformation?.email}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className=" flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Phone color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Phone Number"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.personalInformation?.phoneNumber}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandlordProfile;
